import { apiClient, FileOCRData } from '@melio/javascript-sdk';

import { useModelApi, UseModelApiProps } from '../../core';
import { FileOCRDataModel } from './types';

export type UseFileOCRDataProps = UseModelApiProps<FileOCRData>;

export const useFileOCRData = (props: UseFileOCRDataProps): FileOCRDataModel => {
  const client = apiClient.files();

  return useModelApi<FileOCRData>({
    ...props,
    queryKey: 'file-ocr',
    queryFn: () => client.getOCRData(props.id as string),
  });
};
